import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Handle, Position } from "reactflow";

import styles from "@components/automations/Automation.module.css";
import Icon from "@components/text/Icon";
import BodyCopy from "@components/typography/BodyCopy";
import { AutomationTriggerBlockKindEnum, AutomationFragment as AutomationType } from "@typing/Generated";
import { automationTriggerBlockDescription } from "@utils/automationUtils";

type AutomationTriggerBlock = Extract<AutomationType["blocks"][number], { __typename: "AutomationTriggerBlock" }>;

type Props = {
  data: {
    block: AutomationTriggerBlock;
    onSelect: (node: Node) => void;
  };
};

const AutomationTriggerBlockNode = ({ data }: Props) => {
  const intl = useIntl();

  const description = useMemo(() => automationTriggerBlockDescription(data.block, intl), [data.block, intl]);

  return (
    <div>
      <IonGrid className="ion-no-padding ion-no-margin">
        <IonRow className={`ion-no-padding ion-no-margin ${styles.blockPrimaryRow}`}>
          <IonCol size="auto">
            <Icon icon="playCircle" spacingEnd />
          </IonCol>
          <IonCol>
            <div className={styles.nodeTypeLabel}>
              <FormattedMessage id="models.automation.triggerBlock" />
            </div>
            <div>
              <BodyCopy color={data.block.triggerBrokenReason ? "danger-500" : "black"}>{description}</BodyCopy>
            </div>
          </IonCol>
          <IonCol
            className={data.block.triggerBlockKind === AutomationTriggerBlockKindEnum.MESSAGE_SENT ? "" : "ion-hide"}
            size="auto"
          >
            <Icon
              hoverContent={intl.formatMessage({
                id: "models.automationTriggerBlock.limitedUsersDescription.messageSent"
              })}
              icon="users"
              spacingEnd
            />
          </IonCol>
        </IonRow>
        <IonRow className={`ion-no-padding ion-no-margin ${styles.blockOutputsRow}`}>
          <FormattedMessage id="models.automation.outputs" />
          {data.block.outputs.map(output => (
            <div className={styles.blockOutput} key={output}>
              {output}
            </div>
          ))}
        </IonRow>
      </IonGrid>
      <Handle id="output" isConnectable={false} position={Position.Bottom} type="source" />
    </div>
  );
};

export default AutomationTriggerBlockNode;
